import { useEffect } from "react";
import { AppToasterV2, MultiStepItemProps } from "@ucl/library";
import { FinancialApplicationSection } from "@/types/enums";
import { PersonalAccountAcceptableUseForm } from "./PersonalAccountAcceptableUseForm";
import { RequireAuth } from "@/lib/auth/RequireAuth";
import { useFinancialApplicationFormSectionValidation, FinancialApplicationFormSectionContextType } from "@/hooks/useFinancialApplicationFormSectionValidation";

export interface PersonalAccountAcceptableUseFormStepProps extends MultiStepItemProps {
  financialApplicationId: string;
}

export const PersonalAccountAcceptableUseFormStep: React.FC<
  PersonalAccountAcceptableUseFormStepProps
> = (props) => {
  return (
    <RequireAuth clientType="consumer">
      <PersonalAccountAcceptableUseFormStepInner {...props} />
    </RequireAuth>
  );
};

const PersonalAccountAcceptableUseFormStepInner: React.FC<
  PersonalAccountAcceptableUseFormStepProps
> = (props) => {
  const { validateFinancialApplicationFormSection } = useFinancialApplicationFormSectionValidation(
    props.financialApplicationId,
    FinancialApplicationSection.PersonalAccountAcceptableUse
  );

  useEffect(() => {
    props.registerSubmit?.(async () => {
      const { isValid } = await validateFinancialApplicationFormSection();

      if (!isValid) {
        AppToasterV2.showFailedActionToaster(
          "Please correct the highlighted fields to proceed.",
          "Action Required"
        );
        return false;
      }
      return true;
    });
  }, [props.financialApplicationId, validateFinancialApplicationFormSection]);

  return (
    <section className="personal-account-acceptable-use step-section">
      <div className="personal-account-acceptable-use__header step-header">
        Additional Information - Personal Accounts
      </div>
      <div className="personal-account-acceptable-use__subtitle step-subtitle">
        Please answer these questions to help us understand how you will use your personal accounts.
      </div>
      <div className="personal-account-acceptable-use-form__content step-content">
        <PersonalAccountAcceptableUseForm 
          financialApplicationId={props.financialApplicationId} 
          validationContextType={FinancialApplicationFormSectionContextType.Applicant}
        />
      </div>
    </section>
  );
};
